const localState = {
  // camelCase
  drawer: null,
  menuItems: [],
  actionMap: {
    action_store_card_modal: 'auth/toggleStoreCardModal',
    action_installment_calculator_modal: 'auth/toggleInstallmentCalculatorModal',
  },
};

const localGetters = {
  // underscore_lowercase
  drawer: state => {
    return state.drawer;
  },
  menuItems: state => state.menuItems,
  menuLabel: (state, getters, rootState, rootGetters) => title => {
    // this is complete BS that we have to do this. Some consistency would be
    // great - or how about the server just send the translated stuff?
    const menuItemKey = `MenuItem.${title}`;
    const menuItemLabel = rootGetters['translations/rawTranslate'](menuItemKey);
    if (menuItemLabel !== menuItemKey) return menuItemLabel;

    const rawLabelKey = `${title}s`;
    const rawLabel = rootGetters['translations/rawTranslate'](rawLabelKey);
    if (rawLabel !== rawLabelKey) return rawLabel;

    const customMetaDataLabel = rootGetters['meta/plural_label'](title);
    if (title !== customMetaDataLabel) return customMetaDataLabel;

    return title;
  },
  translateMenuAction: (state) => name => {
    return state.actionMap[name];
  },
};

const localActions = {
  // camelCase
  toggleState({ commit }) {
    commit('toggle_state');
  },
  initializeMenuData({ commit }, menuTree) {
    commit('set_menu_tree', menuTree);
  },
};

const localMutations = {
  // underscore_case
  toggle_state(state) {
    state.drawer = !state.drawer;
  },
  set_menu_tree(state, tree) {
    state.menuItems = tree;
  },
};

export default {
  namespaced: true,
  state: localState,
  getters: localGetters,
  actions: localActions,
  mutations: localMutations,
};
